import { Link as RouterLink } from 'react-router-dom';

import { Box } from '@provider-portal/design-common/kalep/components/Box/Box';

import { BoltMerchantLogoIcon } from '../icons/BoltMerchantLogoIcon';

export const NavBarLogo = () => {
  return (
    <Box pl="12px">
      <RouterLink to="/">
        <BoltMerchantLogoIcon />
      </RouterLink>
    </Box>
  );
};
